/**
 * @file AdminLandingView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { CustomTabPanel, a11yProps } from "../../../common/customviews/CustomTabPanel";
import UserLandingView from "./UserLandingView";
import { AdminViewModel } from "../viewmodels/AdminViewModel";
import { Clinic } from "../../../../services/models/Clinic";
import { BaseComponent } from "../../base/BaseComponent";
import { ClinicLandingView } from "./ClinicLandingView";
import styled from "@emotion/styled";
import './AdminHome.css';
/**
 * A type of Component state
 */
type CompState = { isLoggedIn: boolean, tabState: number };

/**
 * An interface definition for Component Props
 */
interface Props { 
   viewModel: AdminViewModel,
   onDisabledClinicSelection: any,
   onEnabledClinicSelection: any
}
 
const StyledTab = styled(Tab)({
   "&.Mui-selected": {
     color: "#086A96"
   }
 });

 
/**
 * A class definition for AdminLandingView
 */
export class AdminLandingView extends BaseComponent<Props, CompState> {

   constructor(props: Props) {
      super(props)

      this.logger.verbose("AdminLandingView()", AdminLandingView.name);
      this.state = { isLoggedIn: true, tabState: 0 };
   }

   /**
    * Handles changes
    * @param event React.SyntheticEvent
    * @param newValue number
    */
   private handleChange = (event: React.SyntheticEvent, newValue: number) => {
      newValue == 1 ? this.props.onDisabledClinicSelection() : this.props.onEnabledClinicSelection();

      this.setState ({
         tabState: newValue
      });
    };

    /**
     * Trigger after clinic selection
     * @param clinic Clinic
     */
    onClinicSelected = (clinic: Clinic) => {
      this.logger.verbose(`AdminLandingView - onClinicSelected( ${JSON.stringify(clinic)})`, AdminLandingView.name);
      this.childPatienListRef.onClinicSelected(clinic);
   }

   childPatienListRef: any; // estling-disable-line

   render() {
      return <>
          <Box className="AdminBoxContainer" sx={{ width: "80%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
               <Tabs value={this.state.tabState} onChange={this.handleChange} aria-label="basic tabs example" textColor="secondary" indicatorColor="secondary"
                     TabIndicatorProps={{
                        style: {
                           backgroundColor: "#086A96",height: "4px"
                         }
                     }}>
                  <StyledTab label="Users" {...a11yProps(0)}  className="Tab"/>
                  <StyledTab label="Clinics" {...a11yProps(1)} className="Tab"/>
               </Tabs>
            </Box>
            <CustomTabPanel value={this.state.tabState} index={0}>
               <UserLandingView ref= {(childRef)=> this.childPatienListRef= childRef}/>
            </CustomTabPanel>
            <CustomTabPanel value={this.state.tabState} index={1}>
               <ClinicLandingView />
            </CustomTabPanel>
         </Box>
      </>
   }

}